import http from '@/services/rest/rest.service';
import {
    IStatTop10ItemModel,
    IGetTop10StatsModel,
    IGetSiteStatsModel,
    ISiteStatsModel,
    IGetPeriodsStatsModel,
    IStatPeriodItemModel,
    ISiteStatsPayoutModel,
    IGetTop10ComputedStatsModel,
    IGetOfficePeriodsChartModel,
    IStatsOfficePeriodChartModel
} from '@/entities';

export default {
    top10(body: IGetTop10StatsModel): Promise<IStatTop10ItemModel[]> {
        return http.post('stats/top10', body);
    },
    top10Computed(
        body: IGetTop10ComputedStatsModel
    ): Promise<IStatTop10ItemModel[]> {
        return http.post('stats/top10/computed', body);
    },
    periods(body: IGetPeriodsStatsModel): Promise<IStatPeriodItemModel[]> {
        return http.post('stats/periods', body);
    },
    sites(body: IGetSiteStatsModel): Promise<ISiteStatsModel> {
        return http.post('stats/sites', body);
    },
    sitesAvp(body: IGetSiteStatsModel): Promise<ISiteStatsModel> {
        return http.post('stats/sites/avp', body);
    },
    sitesPayout(body: IGetSiteStatsModel): Promise<ISiteStatsPayoutModel> {
        return http.post('stats/sites-payout', body);
    },
    sitesAvpPayout(body: IGetSiteStatsModel): Promise<ISiteStatsPayoutModel> {
        return http.post('stats/sites-payout/avp', body);
    },
    officeCharts(
        body: IGetOfficePeriodsChartModel
    ): Promise<IStatsOfficePeriodChartModel[]> {
        return http.post('stats/office-charts', body);
    }
};
